import { LabelList as RechartsLabelList } from 'recharts';

export const LabelList = (
    props: React.ComponentProps<typeof RechartsLabelList>
) => {
    return (
        <RechartsLabelList
            data-testid={'LabelList-container'}
            {...props}
        />
    );
};

export default LabelList;
